import { API } from 'aws-amplify';
import ReactMarkdown from 'react-markdown';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../../shared/Button';
import { defaultLanding } from '../../../utils/enums';
import { ProtectedRouteContext } from '../../Context';

import './Delete.scss';
import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';

export default function Delete(props) {
    const applicationInstance = props.applicationInstance;
    const { userSettings } = useContext(ProtectedRouteContext);
    const [confirmed, setConfirmed] = useState(false);
    const [doingAjax, setDoingAjax] = useState(false);
    const history = useHistory();

    var studentName = applicationInstance.StudentName || '';

    if (!studentName.trim()) {
        studentName = t('Applications.NoName');
    }

    const handleConfirmationChange = () => {
        setConfirmed(!confirmed);
    };

    const handleCancel = () => {
        setConfirmed(false);
        setDoingAjax(false);
        props.close();
    };

    const handleDelete = async () => {
        setDoingAjax(true);
        try {
            var response = await API.del('ShipyardAPI', '/application/' + applicationInstance.ID);
        } catch (apiDelErr) {
            console.error('API error', apiDelErr);
            toast.error(t('General.AjaxError'));
            history.push(defaultLanding(userSettings.UserType));
            return;
        }
        if (!response.success) {
            console.error('Error deleting application');
            toast.error(t('General.AjaxError'));
            history.push(defaultLanding(userSettings.UserType));
            return;
        }
        toast.success(t('Applications.Delete.Success', { studentName: studentName }));
        setConfirmed(false);
        setDoingAjax(false);
        props.close(true);
    };

    return (
        <Dialog open={true}>
            <DialogTitle>
                <ReactMarkdown>{t('Applications.Delete.Header', { studentName: studentName })}</ReactMarkdown>
            </DialogTitle>
            <DialogContent>
                <Box className="body">
                    <ReactMarkdown>{t('Applications.Delete.Body')}</ReactMarkdown>
                    <div className="confirmation">
                        <label>
                            <input
                                type="checkbox"
                                checked={confirmed}
                                onChange={handleConfirmationChange}
                            />
                            <ReactMarkdown>{t('Applications.Delete.Confirmation')}</ReactMarkdown>
                        </label>
                    </div>
                </Box>
                <Box>
                    <Button
                        useMui={true}
                        type="grey"
                        defaultText={t('General.Cancel')}
                        disabled={doingAjax}
                        onClick={handleCancel}
                        interactive={false}
                    />
                    <Button
                        useMui={true}
                        defaultText={t('Applications.Delete.Action')}
                        disabled={!confirmed | doingAjax}
                        onClick={handleDelete}
                        interactive={false}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
}
